<template>
  <div class="users-pie-chart-container">
    <v-chart :options="option" :autoresize="true" id="pie-chart"></v-chart>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/pie";
import { mapGetters } from "vuex";

export default {
  name: "sdcs",
  data() {
    return {
      singlePlayer: 0,
      multiPlayer: 0,
      option: {}
    };
  },
  components: {
    "v-chart": ECharts
  },
  computed: {
    ...mapGetters(["getSkillgamePercentageUsage"])
  },
  methods: {
    drawGraph() {
      this.option = {
        backgroundColor: " #383838",
        series: [
          {
            silent: true,
            animationDuration: 0,
            backgroundColor: "#fff",

            name: "Number-graph",
            type: "pie",
            startAngle: 30,
            radius: ["60%", "0%"],
            // width: "100%",
            center: ["50%", "50%"],
            label: { position: "inner" },
            labelLine: { show: false },
            animation: false,
            legendHoverLink: false,
            hoverAnimation: false,
            selectedMode: false,
            data: [
              {
                value: this.getSkillgamePercentageUsage.singlePlayer,
                name: this.getSkillgamePercentageUsage.singlePlayer + " %",
                itemStyle: { color: "#0bc6d8" }
              },
              {
                value: this.getSkillgamePercentageUsage.multiPlayer,
                name: this.getSkillgamePercentageUsage.multiPlayer + " %",
                itemStyle: { color: "#8848e4" }
              }
            ]
          },

          {
            name: "Total selected: ",
            type: "pie",
            radius: ["60px", "0%"],
            // width: "100%",
            center: ["50%", "50%"],
            startAngle: 30,
            silent: true,
            animationDuration: 0,
            label: {
              formatter: "{per|{b}} ",
              rich: {
                b: {
                  fontSize: 16,
                  lineHeight: 33
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#353535",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            },

            labelLine: {
              length: 80,
              // distanceToLabelLine: 9,
              length2: 60,
              lineStyle: {
                type: "dashed",
                color: "#ffffff"
              }
            },
            data: [
              {
                value: this.getSkillgamePercentageUsage.singlePlayer,
                name: "Singleplayer",
                itemStyle: { color: "#0bc6d8" }
              },
              {
                value: this.getSkillgamePercentageUsage.multiPlayer,
                name: "Multiplayer",
                itemStyle: { color: "#8848e4" }
              }
            ]
          }
        ]
      };
    }
  },

  watch: {
    getSkillgamePercentageUsage() {
      this.drawGraph();
    }
  }
};
</script>

<style>
#pie-chart {
  width: inherit;
  height: 248px;
}

.users-pie-chart-container {
  height: 248px;
}
</style>
